'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dashboardUrl", "onExitClick"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ExitButton extends Component {
  constructor(props) {
    super(props);
    this.handleExitClick = this.handleExitClick.bind(this);
  }
  handleExitClick(...args) {
    const {
      onExitClick
    } = this.props;
    if (onExitClick) {
      onExitClick(...args);
    }
  }
  render() {
    // eslint-disable-next-line no-unused-vars
    const _this$props = this.props,
      {
        dashboardUrl
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIButton, Object.assign({
      use: "secondary-ghost",
      href: dashboardUrl,
      size: "small",
      onClick: this.handleExitClick
    }, rest, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.header.backLink.exit"
      })
    }));
  }
}
ExitButton.propTypes = {
  dashboardUrl: PropTypes.string,
  onExitClick: PropTypes.func
};